/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const productDetailsContainerSX = ({ isMobile }: { isMobile?: boolean }): SxProps => ({
	p: isMobile ? '0px' : '13px 0px',
	backgroundColor: '#FBFBFC',
	boxShadow: 'none',
	marginBottom: isMobile ? '30px' : '60px',
	marginTop: isMobile ? '30px' : '60px',
});
